import { Component, OnInit } from '@angular/core';
import { HxPagedListDirective } from 'hx-components';
import { HxCategoryService, HxRecipeService, HxRecipeTypePipe, HxUiLabelPipe, PagedList, RecipeInfoModel, WorkflowModel, WorkflowStepModel } from 'hx-services';
import { ActivatedRoute, Data, Router, RouterLink } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { TranslocoDirective, TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { takeUntil } from 'rxjs/operators';
import { firstValueFrom } from 'rxjs';
import { NzAffixComponent } from 'ng-zorro-antd/affix';
import { HxBreadcrumbsComponent } from '@adm-web-app/components/breadcrumbs/breadcrumbs.component';
import { NzPageHeaderComponent, NzPageHeaderExtraDirective, NzPageHeaderSubtitleDirective, NzPageHeaderTitleDirective } from 'ng-zorro-antd/page-header';
import { NzButtonComponent, NzButtonGroupComponent } from 'ng-zorro-antd/button';

import { NzIconDirective } from 'ng-zorro-antd/icon';
import { NzTableCellDirective, NzTableComponent, NzTbodyComponent, NzTheadComponent, NzThMeasureDirective, NzTrDirective } from 'ng-zorro-antd/table';
import { NgFor } from '@angular/common';
import { NzWaveDirective } from 'ng-zorro-antd/core/wave';
import { NzPopconfirmDirective } from 'ng-zorro-antd/popconfirm';

@Component({
    selector: 'hc-workflow-recipe-list',
    templateUrl: './workflow-recipe-list.component.html',
    styleUrls: ['./workflow-recipe-list.component.less'],
  imports: [TranslocoDirective, NzAffixComponent, HxBreadcrumbsComponent, NzPageHeaderComponent, NzPageHeaderTitleDirective, NzPageHeaderSubtitleDirective, NzPageHeaderExtraDirective, NzButtonComponent, RouterLink, NzIconDirective, NzTableComponent, NzTheadComponent, NzTrDirective, NzTableCellDirective, NzThMeasureDirective, NzTbodyComponent, NgFor, NzButtonGroupComponent, NzWaveDirective, NzPopconfirmDirective, HxUiLabelPipe, HxRecipeTypePipe, TranslocoPipe]
})
export class WorkflowRecipeListComponent extends HxPagedListDirective<RecipeInfoModel> implements OnInit {

  workflow!: WorkflowModel;
  step!: WorkflowStepModel;

  constructor(
    override router: Router,
    override aRoute: ActivatedRoute,
    protected api: HxRecipeService,
    protected notification: NzNotificationService,
    protected tr: TranslocoService,
    protected categoryService: HxCategoryService,
  ) {
    super(router, aRoute);
    this.limit = 20;
  }

  ngOnInit() {
    const routeData: Data = this.aRoute.snapshot.data;
    this.workflow = routeData['workflow'] as WorkflowModel;
    this.step = routeData['step'] as WorkflowStepModel;
    this.aRoute.queryParamMap.pipe(takeUntil(this.$destroyed))
      .subscribe(paramMap => {
        super.load(paramMap);
      });
  }

  async remove(id: number): Promise<void> {
    await this.api.deleteRecipe(id);
    this.loadData();
    this.notification.success(this.tr.translate('nav.WorkflowRecipes'), this.tr.translate('nt.dataRemoved'));
  }

  protected loadList(): Promise<PagedList<RecipeInfoModel>> {
    return this.api.getRecipeList({stepId: this.step.id});
  }
}
